const RestrictionsFacade = require('../facade/restrictions/restrictions');
const OverOutHandler = require('./helper/overwritable').OverOutHandler;
const getElementOnCoords = require('./helper/overwritable').getElementOnCoords;

module.exports = function (S) {
  const overHandler = new OverOutHandler(S, 'ghost-logo');

  return {
    outLogo: overHandler.out,
    updateLogoDimensions: function (opts) {
      overHandler.updateContentDimensions(opts.elem);
    },
    dragLogo: function (opts) {
      const logos = $(S.svgroot).find('.element.logo');
      const logoOnPosition = getElementOnCoords(logos, opts.x, opts.y, S.canvas.getZoom());

      if (logoOnPosition) {
        const isRestricted = !RestrictionsFacade.canChange(logoOnPosition, 'replace') ||
          RestrictionsFacade.getElementRestrictions(logoOnPosition.getAttribute('id'), 'source').length;

        isRestricted && S.canvas.call('advice.show', 'restriction-logo-replace');
        isRestricted || overHandler.over(logoOnPosition, opts.thumb);
      } else if (overHandler.getGhostElement()) overHandler.out();

      return logoOnPosition;
    }
  };
};
